import { createGet, createGetByText, createPost } from './base.js';

export const GetConstant = createGet('constant');
export const GetByTextConstant = createGetByText('constant');
export const PostConstant = createPost('constant');
